
import axios from "axios"
import { GENERAL_URL_API } from "../../components/Store";



/**
 * Verifica el estado de la conexi n a internet.
 * @param {{abortSignal:AbortSignal}} options - Opciones de configuraci n.
 * @param {AbortSignal} options.abortSignal - Se al de aborto para cancelar la solicitud.
 * @returns {Promise<'online' | 'offline'>} - Una promesa que resuelve en el estado de la conexi n a internet.
 */
const checkNetworkStatus = async ({abortSignal=null})=>{
    try {
        axios.defaults.baseURL = GENERAL_URL_API;
        axios.defaults.withCredentials = true;

    
        const response = await axios({
          method: 'POST',
          url: `assets/network-status`,
          signal: abortSignal || null,
          headers:{'Content-Type':'application/x-www-form-urlencoded'},
        })
        const status = response.status;
        const data = response.data;
        if(status === 200 && data === 'online'){
          return 'online'
        }
        if(status === 200 && data === 'offline'){
         throw new Error('offline')
        }
        return response;
      } catch (error) {
        return Promise.reject(error);
      }
    
}


export const NetworkAPI = {
   checkNetworkStatus
}